import QuantityActionTypes from '../actionTypes/QuantityActionTypes';

const QuantityReducer = function QuantityReducer(state = 1, action) {
    switch (action.type) {
        case QuantityActionTypes.QUANTITY_ON_CHANGE:
            return action.payload;
        case QuantityActionTypes.QUANTITY_RESET:
            return 1;
        default:
            return state;
    }
};

// QuantityReducer.reducerName = 'selectedQuantity';

export default QuantityReducer;
